import React from 'react'

export default function UrlNotFound() {
  return (
    <>
    <div className='text-center text404'><span>404</span></div>
    <div className='text-center'><img style={{width:'150px'}} src='assets/images/icons/scissor.png'/> </div>
    <div className='text-center fs-6 mt-5'><span className='nft'>Requested Page is not found</span></div>
    </>
  )
}
